// extracted by mini-css-extract-plugin
module.exports = {"ExpandButton__expand-button__27VN7":"ExpandButton__expand-button__27VN7","ExpandButton__button__2MyFL":"ExpandButton__button__2MyFL"};